import { useState } from 'react';

const ContactModal = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    service: 'AI Edits',
    message: ''
  });

  const services = [
    '3D Animation',
    'VFX',
    'Motion Graphics',
    'AI Edits',
    'Graphic Design',
    'Other'
  ];

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Create mailto link or handle form submission
    const subject = `Inquiry for ${formData.service}`;
    const body = `Name: ${formData.name}%0D%0AEmail: ${formData.email}%0D%0AService: ${formData.service}%0D%0A%0D%0AMessage:%0D%0A${formData.message}`;
    window.open(`mailto:info@zyfox.in?subject=${subject}&body=${body}`, '_blank');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-black/80 backdrop-blur-sm"
        onClick={onClose}
      ></div>
      
      {/* Modal */}
      <div className="relative w-full max-w-lg glass-panel rounded-2xl p-6 sm:p-8 animate-fade-in-up">
        {/* Close button */}
        <button 
          onClick={onClose}
          className="absolute top-4 right-4 text-white/50 hover:text-white transition-colors"
        >
          <span className="material-symbols-outlined">close</span>
        </button>

        {/* Header */}
        <div className="text-center mb-6">
          <h2 className="text-2xl sm:text-3xl font-bold text-white mb-2">Get in Touch</h2>
          <p className="text-white/60 text-sm">Let's create something extraordinary together.</p>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
              required
              className="w-full px-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white placeholder-white/40 focus:outline-none focus:border-primary transition-colors"
            />
          </div>

          <div>
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              value={formData.email}
              onChange={handleChange}
              required
              className="w-full px-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white placeholder-white/40 focus:outline-none focus:border-primary transition-colors"
            />
          </div>

          <div>
            <select
              name="service"
              value={formData.service}
              onChange={handleChange}
              className="w-full px-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white focus:outline-none focus:border-primary transition-colors appearance-none cursor-pointer"
              style={{ backgroundImage: 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' fill=\'none\' viewBox=\'0 0 24 24\' stroke=\'white\'%3E%3Cpath stroke-linecap=\'round\' stroke-linejoin=\'round\' stroke-width=\'2\' d=\'M19 9l-7 7-7-7\'%3E%3C/path%3E%3C/svg%3E")', backgroundRepeat: 'no-repeat', backgroundPosition: 'right 1rem center', backgroundSize: '1.5rem' }}
            >
              <option value="" disabled className="bg-gray-900">Select Service</option>
              {services.map((service) => (
                <option key={service} value={service} className="bg-gray-900">{service}</option>
              ))}
            </select>
          </div>

          <div>
            <textarea
              name="message"
              placeholder="Your Message"
              value={formData.message}
              onChange={handleChange}
              rows={4}
              className="w-full px-4 py-3 rounded-xl bg-white/5 border border-white/10 text-white placeholder-white/40 focus:outline-none focus:border-primary transition-colors resize-none"
            ></textarea>
          </div>

          <button
            type="submit"
            className="w-full btn-glow flex h-12 items-center justify-center rounded-full bg-primary text-sm font-bold text-background-dark"
          >
            Send Message
          </button>
        </form>

        {/* Contact Info */}
        <div className="mt-6 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 text-sm text-white/50">
          <a href="tel:+916366983700" className="flex items-center gap-2 hover:text-primary transition-colors">
            <span className="material-symbols-outlined text-primary text-sm">phone</span>
            +91 6366983700
          </a>
          <a href="mailto:info@zyfox.in" className="flex items-center gap-2 hover:text-primary transition-colors">
            <span className="material-symbols-outlined text-primary text-sm">mail</span>
            info@zyfox.in
          </a>
        </div>
      </div>
    </div>
  );
};

export default ContactModal;
